// # Maintenance Signin Page Component
import React from 'react';
import './signin_mock.css';
import AuthHeader from '../components/AuthHeader';
import { FaTools } from 'react-icons/fa';

function SigninMock() {
  return (
    <div>
      <AuthHeader />
      <div className="sgnn_mock_signin-container">
        <div className="sgnn_mock_signin-image-section" />
        <div className="sgnn_mock_maintenance-section">
          <div className="sgnn_mock_maintenance-icon">
            <FaTools />
          </div>
          <h2 className="sgnn_mock_maintenance-title">Under Maintenance</h2>
          <p className="sgnn_mock_maintenance-message">
            We're currently updating our sign-in system to serve you better.
            The sign-in functionality will be available soon.
          </p>
          <p className="sgnn_mock_maintenance-message">
            Thank you for your patience and understanding.
          </p>
          <div className="sgnn_mock_maintenance-contact">
            Need assistance? Contact us at{' '}
            <a href="mailto:customer-service@wearetempu.com">customer-service@wearetempu.com</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SigninMock;
